import { ProctoringOptionCategory } from "../proctoring-options/option-text/ProctoringOptionText";
import ProctoringOptions, { ProctoringOptionsProps } from "../proctoring-options/proctoringOptionsGrid";
import styles from "./index.module.css";
import { CoreLoadingPage } from "../../core/progress-indicators/Spinner";
import { ProctoringDataType } from "../hooks/state/useSettingsState";
import { EditQuizPageProps } from "../editQuiz";
import { StepWrapper } from "./CommonStepComponents";
import type { CoreFileItem } from "../../core";

export type ConfigurationStepProps = {
	loading?: boolean;
	currentCategory: ProctoringOptionCategory;
	data: ProctoringDataType;
	proctoringAssessmentConfiguration: NonNullable<EditQuizPageProps["proctoringAssessmentConfiguration"]>;
	referenceMaterialFiles: CoreFileItem[] | undefined;
	onUpdateReferenceMaterialFiles: (files: CoreFileItem[]) => void;
} & Pick<
	ProctoringOptionsProps,
	| "data"
	| "enabledProctoringOptions"
	| "enforcedProfilesOnly"
	| "optionRelatedInstituteSettings"
	| "proctoringOption"
	| "setProctoringOption"
	| "verityInstituteSettings"
	| "quizType"
	| "api"
>;

export default function ConfigurationStep({
	loading,
	data,
	currentCategory,
	proctoringAssessmentConfiguration,
	enabledProctoringOptions,
	enforcedProfilesOnly,
	proctoringOption,
	setProctoringOption,
	verityInstituteSettings,
	optionRelatedInstituteSettings,
	quizType,
	referenceMaterialFiles,
	onUpdateReferenceMaterialFiles,
	api,
}: ConfigurationStepProps) {
	const hasPassword = Boolean(
		proctoringAssessmentConfiguration.thirdPartyAssessmentOption?.password &&
			proctoringAssessmentConfiguration.thirdPartyAssessmentOption?.password !== "",
	);
	const isThirdPartyEnabled = Boolean(proctoringAssessmentConfiguration.thirdPartyAssessmentOption);

	if (loading) return <CoreLoadingPage size={100} />;

	return (
		<StepWrapper>
			<div className={styles.configurationPage}>
				<ProctoringOptions
					data={data}
					currentCategory={currentCategory}
					hasPassword={hasPassword}
					isThirdPartyEnabled={isThirdPartyEnabled}
					enabledProctoringOptions={enabledProctoringOptions}
					enforcedProfilesOnly={enforcedProfilesOnly}
					proctoringOption={proctoringOption}
					setProctoringOption={setProctoringOption}
					verityInstituteSettings={verityInstituteSettings}
					optionRelatedInstituteSettings={optionRelatedInstituteSettings}
					quizType={quizType}
					referenceMaterialFiles={referenceMaterialFiles}
					onUpdateReferenceMaterialFiles={onUpdateReferenceMaterialFiles}
					api={api}
				/>
			</div>
		</StepWrapper>
	);
}
